<template>
  <div class="container stepper">
    <ul>
      <li :class="{active: step == 1, completed: step > 1}" @click="describeClick()">
        <span class="step-i"><span class='num'>1</span><i class="check material-icons">check</i></span>
        <span class="step-name">Describe</span>
      </li>
      <!-- <li class="spacer"></li>
      <li>
        <span class="step-i">2</span>
        <span class="step-name">Organize</span>
      </li> -->
      <li class="spacer"></li>

      <li :class="{active: step == 2, completed: step > 2}" @click="buildClick()">
        <span class="step-i"><span class='num'>2</span><i class="check material-icons">check</i></span>
        <span class="step-name">Build</span>
      </li>
      <li class="spacer"></li>

      <li :class="{active: step == 3, completed: step > 3}" >
        <span class="step-i"><span class='num'>3</span><i class="check material-icons">check</i></span>
        <span class="step-name">Preview</span>
      </li>
    </ul>
  </div>
</template>


<script>
export default {
  props: [
    "step",
    
  ],

  data() {
    return {
    };
  },
  computed: {},
  updated() {},
  mounted() {},

  methods: {
    displayStepNumber(i) {
   
    },
    describeClick() {
      if (this.step > 1) {
        window.location = "/tutorials/describe/"+this.$route.params.id
      }
    },
    buildClick() {
      if (this.step > 2) {
        window.location = "/tutorials/build/"+this.$route.params.id
      }
    },
  }
};
</script>

<style scoped>
.stepper {
  margin-top: 130px;
}
ul {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
li {
    white-space: nowrap;
    display: inline-flex;
}
.check {
  display: none;
}
.completed {
  cursor: pointer;
}
.completed .step-name{
  color: rgba(0,0,0,0.87);
}
.completed .check {
  display: inline-block;
}
.completed .num {
  display: none;
}
.step-i {
  height: 24px;
  width: 24px;
  background: gray;
  color: white;
  border-radius: 24px;
  font-size: 12px;
  display: inline-block;
  text-align: center;
  line-height: 24px;
  margin-right: 8px;
}
.step-name {
  font-size: 14px;
  line-height: 24px;
  color: rgba(0,0,0,0.38);
}
.active .step-i, .completed .step-i {
    background: #27aae1;
}
.active .step-name {
    color: rgba(0,0,0,0.87);
      font-weight: 500;

}
.spacer {
    width: 100%;
    border-top: 1px solid  rgba(0, 0, 0, 0.38);

    margin: 8px;
    margin-top: 9px;
}
</style>


// WEBPACK FOOTER //
// src/components/Stepper.vue